// The one place the app's own name and fixed product constants live.
// Components read from here; they never carry these strings themselves.

export const APP_NAME = 'Cuplzap'

export const APP_TAGLINE = 'Our household tasks and calendar.'

/** The release running now: web/package.json's version. Every release has a src/changelog.json entry. */
export const APP_VERSION = __APP_VERSION__

/** When this build was made, in ms since 1970. */
export const APP_BUILT_AT = __APP_BUILT_AT__

/** Where the app is served in production. */
export const APP_ORIGIN = 'https://my.cuplzap.com'

/** The Cloud Functions region, matching functions/src/index.ts. */
export const FUNCTIONS_REGION = 'europe-west1'

/** Starter categories offered at first run, in order, with their palette keys. */
export const STARTER_CATEGORIES = [
  { name: 'Home', color: 'c1' },
  { name: 'Errands', color: 'c2' },
  { name: 'Money', color: 'c3' },
  { name: 'Health', color: 'c4' },
  { name: 'Admin', color: 'c5' },
  { name: 'Trips', color: 'c6' },
] as const

/** Ticked one-offs stay loaded, and in search results, for this long. */
export const DONE_WINDOW_DAYS = 30

/** The morning summary's default hour, in the household time zone. */
export const DEFAULT_SUMMARY_TIME = '08:00'

/** The two Google Calendar scopes the app asks for: read-only, because Cuplzap never writes to Google. */
export const GOOGLE_CALENDAR_SCOPES = ['https://www.googleapis.com/auth/calendar.events.readonly', 'https://www.googleapis.com/auth/calendar.calendarlist.readonly']
